module.exports = __webpack_public_path__ + "img/baleno-banner.8796f629.svg";